<template>
    <div>
        <div class="min-h-screen bg-gray-400">
            <nav class="bg-gray-700 border-b border-gray-800">
                <!-- Primary Navigation Menu -->
                <div class="mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="flex justify-between h-12">
                        <div class="flex">
                            <!-- Logo -->
                            <div class="flex-shrink-0 flex items-center">
                                <Link :href="this.$page.props.auth.home">
                                    <application-logo class="block h-7 w-auto" />
                                </Link>
                            </div>



                            <!-- Navigation Links -->
                            <div v-for="n in navigation" v-show="n.show" class="hidden space-x-8 sm:-my-px sm:ml-6 sm:flex">
                                <nav-link :href="n.href" :active="n.active">{{ n.title }}</nav-link>
                            </div>

                        </div>

                        <div class="hidden sm:flex sm:items-center">
                            <!-- Settings Dropdown -->
                            <div class="relative">
                                <BreezeDropdown align="right" width="48">
                                    <template #trigger>
                                        <span class="inline-flex rounded-md">
                                            <button
                                                type="button"
                                                class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-600 hover:text-gray-200 focus:outline-none transition ease-in-out duration-150 capitalize"
                                            >
                                                {{ $page.props.auth.user.name }}

                                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                </svg>
                                            </button>
                                        </span>
                                    </template>

                                    <template #content>

                                        <BreezeDropdownLink :href="route('settings.profile')" as="button">
                                            Профиль
                                        </BreezeDropdownLink>

                                        <BreezeDropdownLink v-if="access('admin', 'available')" :href="route('admin.settings.index')" as="button">
                                            Администрирование
                                        </BreezeDropdownLink>

                                        <hr>

                                        <BreezeDropdownLink :href="route('logout')" method="post" as="button" class="text-red-600">
                                            Выход
                                        </BreezeDropdownLink>

                                    </template>
                                </BreezeDropdown>
                            </div>
                        </div>

                        <!-- Hamburger -->
                        <div class="-mr-2 flex items-center sm:hidden">
                            <button @click="showingNavigationDropdown = ! showingNavigationDropdown" class="inline-flex items-center justify-center p-2 rounded-md text-gray-200 hover:text-gray-200 focus:outline-none transition duration-150 ease-in-out">
                                <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    <path :class="{'hidden': showingNavigationDropdown, 'inline-flex': ! showingNavigationDropdown }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                                    <path :class="{'hidden': ! showingNavigationDropdown, 'inline-flex': showingNavigationDropdown }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Responsive Navigation Menu -->
                <div :class="{'block': showingNavigationDropdown, 'hidden': !showingNavigationDropdown}" class="sm:hidden bg-gray-600">


                    <div v-for="n in navigation" v-show="n.show" class="space-y-1">
                        <responsive-nav-link :href="n.href" :active="n.active">{{ n.title }}</responsive-nav-link>
                    </div>

                    <!-- Responsive Settings Options -->
                    <div class="pt-4 pb-1 border-t border-b border-gray-400 bg-gray-600">
                        <div class="px-4">
                            <div class="font-medium text-base text-gray-200">{{ $page.props.auth.user.name }}</div>
                        </div>
                        <div class="mt-3 space-y-1">
                            <responsive-nav-link :href="route('settings.profile')" as="button">
                                Настройки
                            </responsive-nav-link>
                        </div>
                        <div class="mt-3 space-y-1 text-red-600">
                            <responsive-nav-link :href="route('logout')" method="post" as="button">
                                Выход
                            </responsive-nav-link>
                        </div>
                    </div>
                </div>
            </nav>

            <!-- Page Heading -->
            <header class="bg-gray-600 shadow overflow-y-auto" v-if="$slots.header">
                    <slot name="header" />
            </header>

            <!-- Page Content -->
            <main>
                <slot />
            </main>

            <div
                v-if="$page.props.notifications"
                class="fixed bottom-12 right-8 flex flex-col gap-4 w-96 text-sm whitespace-pre-wrap"
            >
                <notification
                    v-for="(notification, index) in $page.props.notifications"
                    :index="index"
                    :data="notification"
                />
            </div>

        </div>
    </div>
</template>

<script>
import ApplicationLogo from '@/Components/ApplicationLogo.vue'
import BreezeDropdown from '@/Components/Dropdown.vue'
import BreezeDropdownLink from '@/Components/DropdownLink.vue'
import NavLink from '@/Components/NavLink.vue'
import ResponsiveNavLink from '@/Components/ResponsiveNavLink.vue'
import { Link } from '@inertiajs/inertia-vue3'
import Notification from '@/Components/Notification'


export default {
    components: {
        ApplicationLogo,
        BreezeDropdown,
        BreezeDropdownLink,
        NavLink,
        ResponsiveNavLink,
        Link,
        Notification,
    },
    data() {
        return {
            showingNavigationDropdown: false,
            navigation: [
                {
                    title: 'Dashboard',
                    show: this.access('dashboard', 'available') && this.$page.props.auth.home !== '/dashboard',
                    href: this.route('dashboard'),
                    active: this.route().current().startsWith('dashboard'),
                },
                {
                    title: 'Пользователи',
                    show: this.access('user', 'available'),
                    href: this.route('ocp.users'),
                    active: this.route().current().startsWith('ocp.users'),
                },
                {
                    title: 'Организации',
                    show: this.access('organizations', 'available'),
                    href: this.route('organizations'),
                    active: this.route().current().startsWith('organizations'),
                },
                {
                    title: 'Транзакции',
                    show: this.access('transactions', 'available'),
                    href: this.route('transactions'),
                    active: this.route().current().startsWith('transactions'),
                },
                {
                    title: 'Адреса',
                    show: this.access('addresses', 'available'),
                    href: this.route('addresses'),
                    active: this.route().current().startsWith('addresses'),
                },
                {
                    title: 'Тарифы',
                    show: this.access('tariffs', 'available'),
                    href: this.route('tariffs'),
                    active: this.route().current().startsWith('tariffs'),
                },
                {
                    title: 'Реферальная',
                    show: this.access('referrals', 'available'),
                    href: this.route('ocp.refferals'),
                    active: this.route().current('ocp.refferals'),
                },
                {
                    title: 'Отчёты',
                    show: true,
                    href: this.route('reports'),
                    active: this.route().current('reports'),
                },
                {
                    title: 'Blockchain',
                    show: this.access('blockchain', 'available'),
                    href: this.route('blockchain'),
                    active: this.route().current('blockchain'),
                },
                {
                    title: 'Биржи',
                    show: this.access('exchanges', 'available'),
                    href: this.route('exchanges.index'),
                    active: this.route().current('exchanges.index'),
                },
                {
                    title: 'Партнеры',
                    show: this.access('partners', 'available'),
                    href: this.route('partners'),
                    active: this.route().current('partners'),
                },
                {
                    title: 'Выводы',
                    show: this.access('withdrawals', 'available'),
                    href: this.route('withdrawals'),
                    active: this.route().current('withdrawals'),
                },
                {
                    title: 'Ордера',
                    show: this.access('orders', 'available'),
                    href: this.route('orders'),
                    active: this.route().current('orders'),
                },
                {
                    title: 'Фиат',
                    show: this.access('fiat', 'available'),
                    href: this.route('fiat'),
                    active: this.route().current('fiat'),
                },
            ],
        }
    },
    mounted() {
        if(!this.$page.props.notifications)
            this.$page.props.notifications = [];
    },
}
</script>
